/**
 * Configurazione dei risparmi per slider_privacy_push
 * Testi bonus da database CAP (stesso meccanismo di slider_all_bonus_short_cap).
 */

import { ProductType, BonusDisplayItem } from '../types';
import { formatCurrency } from '../utils/helpers';
import {
  getBonusesForCap,
  getTooltipTextForProduct,
  formatBonusForDisplay,
} from './bonusLookup';
import { getBenefitKeyForSlide } from './slidesConfig';

/**
 * Mappa le chiavi benefit (post mapping slide) agli indici dei 4 bonus in slideBonus
 */
const SLIDE_TO_BONUS_INDEX: Record<string, number> = {
  install_timeline: 0,
  name_form: 1,
  email_form: 2,
  phone_form: 3,
};

export function getTooltipText(productType?: ProductType): string {
  return getTooltipTextForProduct(productType);
}

export function getBonusCountText(
  slideId: string,
  _productType?: ProductType,
  _zipCode?: string
): string {
  const benefitKey = getBenefitKeyForSlide(slideId);
  const bonusIndex = SLIDE_TO_BONUS_INDEX[benefitKey];

  if (bonusIndex === undefined) return '';

  if (slideId === 'phone_form') {
    return 'VANTAGGIO 4/5';
  }

  return `VANTAGGIO ${bonusIndex + 1}/5`;
}

export function getSavingsText(
  slideId: string,
  productType?: ProductType,
  _zipFlag?: boolean | null,
  zipCode?: string
): string | null {
  const benefitKey = getBenefitKeyForSlide(slideId);
  const bonusIndex = SLIDE_TO_BONUS_INDEX[benefitKey];

  if (bonusIndex === undefined) return null;

  const bonuses = getBonusesForCap(zipCode, productType);
  const bonus = bonuses.slideBonus[bonusIndex];

  if (!bonus) return null;

  return formatBonusForDisplay(bonus.value, bonus.label);
}

export function calculateTotalSavings(
  slideId: string,
  productType?: ProductType,
  _zipFlag?: boolean | null,
  zipCode?: string
): string {
  const benefitKey = getBenefitKeyForSlide(slideId);
  const currentIndex = SLIDE_TO_BONUS_INDEX[benefitKey];

  if (currentIndex === undefined) return '';

  const bonuses = getBonusesForCap(zipCode, productType);

  let total = 0;
  for (let i = 0; i <= currentIndex && i < bonuses.slideBonus.length; i++) {
    total += bonuses.slideBonus[i].value;
  }

  return formatCurrency(total);
}

/**
 * Conteggio bonus per il banner verde sulla slide CAP (come slider_all_bonus)
 */
export function calculateBonusSummary(
  productType?: ProductType,
  _zipFlag?: boolean | null,
  zipCode?: string
): { bonusCount: number; totalSavings: number } {
  const bonuses = getBonusesForCap(zipCode, productType);

  return {
    bonusCount: bonuses.bonusCount + 1,
    totalSavings: bonuses.total,
  };
}

export interface SavingsSummaryItem {
  label: string;
  value: string;
  scadenza?: string | null;
  category?: 'PV' | 'HP';
}

export function generateSavingsSummary(
  productType?: ProductType,
  _zipFlag?: boolean | null,
  zipCode?: string
): {
  items: SavingsSummaryItem[];
  total: number;
  co2Saved: string;
} {
  const bonuses = getBonusesForCap(zipCode, productType);

  const items: SavingsSummaryItem[] = bonuses.summaryBonus.map((bonus: BonusDisplayItem) => ({
    label: bonus.label,
    value: formatCurrency(bonus.value),
    scadenza: bonus.scadenza,
    category: bonus.category,
  }));

  return {
    items,
    total: bonuses.total,
    co2Saved: 'Scoprilo in chiamata',
  };
}
